module.exports = __webpack_public_path__ + "img/ar2021_icon-stewardship.834a96de.png";